import FeeHelper from "../../utils/FeeHelper";
import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import classnames from "classnames";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import CustomCurrencyInput from "../../components/CustomCurrencyInput";
import useFeeStateHook from "../../hooks/useFeeStateHook";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {useDealContext} from "../../contexts/DealContext";

export const DealPageFee = ({fee, isLoading, isTabletOrMobile, isCappingDisabled, isEditingDisabled}) => {
    const [feeState, setFeeStateWithUpdate] = useFeeStateHook(fee)
    const {isHistorical} = useDealContext()

    if (!feeState) return null;

    const isFinanced = feeState.is_capped
    const isNotEditable = !fee.is_editable

    return (
        <TableRow
            key={fee.id}
            sx={{
                '&:last-child td, &:last-child th': {border: 0},
                height: '10px',
            }}
        >

            <TableCell
                className={'DealPageFee fee-name'}
                scope="row"
                size={'small'}
                width={isTabletOrMobile ? (isCappingDisabled ? '70%' : '55%') : (isCappingDisabled ? '85%' : '70%')}
                align="left"
            >
                {feeState.name}
            </TableCell>
            {
                !isCappingDisabled &&
                <TableCell
                    className={'DealPageFee'}
                    align="center"
                    size={'small'}
                    width={'15%'}
                >
                    <Tooltip title={isFinanced ? "Upfront" : "Cap"} arrow placement={'top'}>
                        <Switch
                            disabled={isLoading || isNotEditable || isHistorical}
                            checked={isFinanced}
                            onChange={() => {
                                setFeeStateWithUpdate({is_capped: !feeState.is_capped})
                            }}
                        />
                    </Tooltip>
                </TableCell>
            }

            <TableCell
                align="right"
                size={'small'}
                className={'DealPageFee'}
                width={isTabletOrMobile ? '30%' : '15%'}
            >
                <div className={'fee-input-wrap'}>
                    <span className={'prefix'}>$</span>
                    <CustomCurrencyInput
                        onChange={(value) => setFeeStateWithUpdate({amount: value}, false)}
                        className={classnames({ loading: isLoading })}
                        value={feeState.amount}
                        key={fee.Id}
                        allowNull={true}
                        disabled={isEditingDisabled || isNotEditable || isHistorical}
                        InputProps={{}}
                    />
                </div>
            </TableCell>
        </TableRow>
    )
}